<template>
	<v-menu offset-y left origin="right top" z-index="99" content-class="notification-dropdown left-0" transition="slide-y-transition" :nudge-top="$vuetify.breakpoint.name === 'sm' ? '0' : '-10'">
		<v-btn icon large slot="activator" class="my-0">
			<i class="zmdi grey--text zmdi-hc-fw font-lg zmdi-apps"></i>
		</v-btn>
		<div class="dropdown-content">
			<div class="dropdown-top d-custom-flex justify-space-between primary">
				<span class="white--text fw-bold">Módulos</span>
			</div>
			<v-list class="dropdown-list">
				<v-list-tile v-for="link in links" :key="link.title" :to="{ name: link.to}">
					<i class="mr-2" :class="link.icon"></i>
					<span>{{ link.title }}</span>
				</v-list-tile>
			</v-list>
		</div>
	</v-menu>
</template>

<script>
import { getCurrentAppLayout } from "Helpers/helpers";
import { mapGetters } from 'vuex'
	export default {
		data(){
			return {
				links: []
			}
		},
		computed: {
            menuPermissions () {
                return {
                    prescripciones: this.$store.getters.getPermission('prescripciones.show'),
					          direccionamientos: this.$store.getters.getPermission('direccionamientos.show'),
                    programaciones: this.$store.getters.getPermission('programaciones.show'),
                    entregas: this.$store.getters.getPermission('entregas.show'),
                    reportesEntregas: this.$store.getters.getPermission('reportesEntregas.show'),
                    reportes: this.$store.getters.getPermission('reportes.show'),
                    mipres: this.$store.getters.getPermission('mipres.show'),
                    facturacion: this.$store.getters.getPermission('facturacion.show'),
					// Administrativo
					empresa: this.$store.getters.getPermission('empresa.show'),
					usuarios: this.$store.getters.getPermission('user.show'),
					sedes: this.$store.getters.getPermission('sedes.show'),
					facturas: this.$store.getters.getPermission('facturas.show'),
					precios: this.$store.getters.getPermission('precios.show')
                }
            }
		},
		mounted () {
            this.menuPermissions.prescripciones && this.links.push({
                title: "Prescripciones",
                to: "Prescripciones",
                icon: "ti-pencil-alt info--text"
            })
			this.menuPermissions.direccionamientos && this.links.push({
                title: "Direccionamientos",
                to: "Direccionamientos",
                icon: "ti-direction-alt primary--text"
            })

            this.menuPermissions.programaciones && this.links.push({
                title: "Programaciones",
                to: "Programaciones",
                icon: "ti-timer purple--text"
            })

            this.menuPermissions.entregas && this.links.push({
                title: "Entregas",
                to: "Entregas",
                icon: "ti-package success--text"
            })

            this.menuPermissions.reportesEntregas && this.links.push({
                title: "Reportes de entrega",
                to: "ReportesEntrega",
                icon: "ti-export info--text"
            })

			this.menuPermissions.facturacion && this.links.push({
				title: "Facturación",
				to: "Facturacion",
				icon: "fas fa-file-invoice-dollar primary--text"
			})

			this.menuPermissions.mipres && this.links.push({
				title: "MIPRES",
				to: "Mipres",
				icon: "zmdi zmdi-balance red--text"
			})

      this.menuPermissions.reportes && this.links.push({
        title: "Reportes",
        to: "Reportes",
        icon: "fas fa-file-excel green--text"
      })

			if (this.menuPermissions.empresa || this.menuPermissions.usuarios || this.menuPermissions.sedes || this.menuPermissions.facturas || this.menuPermissions.precios) {
				this.links.push({
					title: "Administrativo",
					to: "Administrativo",
					icon: "fas fa-cogs warning--text"
				})
			}
		},
		methods: {
		}
	};
</script>

<style scoped>
	.left-0 {
		left: 0px !important;
	}
</style>
